// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// import * as Sentry from '@sentry/nextjs'

// Sentry.init({
//   dsn: 'https://ed213cc10c12059fcb0be2c641ae99d0@o4505942694756352.ingest.us.sentry.io/4507683861168128',

//   // Adjust this value in production, or use tracesSampler for greater control
//   tracesSampleRate: 0.005,

//   // Setting this option to true will print useful information to the console while you're setting up Sentry.
//   debug: false,

//   enabled: process.env.NODE_ENV === 'production',

//   // You can remove this option if you're not planning to use the Sentry Session Replay feature:
//   integrations: [

//   ]
// })

// export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
